import React from 'react';

import { matchPath, useLocation } from 'react-router-dom';

import { LeftMenu } from '@packages/components/left-menu/left-menu';
import {
  CONTACT_CONCIERGE_ROUTE,
  COVERAGE_SCORE_ROUTE,
  LOG_SEARCH_DOWNLOAD_ROUTE,
} from 'ae-constants/routes.constants';

import { useLeftMenuItems } from './hooks/use-left-menu-items';

const HIDE_LEFT_MENU_ROUTES = [
  LOG_SEARCH_DOWNLOAD_ROUTE,
  CONTACT_CONCIERGE_ROUTE,
  COVERAGE_SCORE_ROUTE,
];

export const DashboardLeftMenu: React.FC = () => {
  const { pathname } = useLocation();
  const items = useLeftMenuItems();

  if (HIDE_LEFT_MENU_ROUTES.some((route) => matchPath(route, pathname))) {
    return null;
  }

  return <LeftMenu items={items} />;
};
